import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const LeadsByOriginChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-5 text-gray-500">
        No leads data available
      </div>
    );
  }

  // 🔥 increase height per bar
  const BAR_HEIGHT = 55;
  const chartHeight = Math.max(data.length * BAR_HEIGHT, 600);

  const labels = data.map((item) =>
    item.origin
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ")
  );

  const counts = data.map((item) => item.count);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Leads Count",
        data: counts,
        barThickness: 28,
        maxBarThickness: 35,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "x",
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: (ctx) => `Leads: ${ctx.raw}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
      y: {
        ticks: {
          autoSkip: false,
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <div className="w-full">
      {/* Scroll Container */}
      <div
        style={{
          height: "600px", // viewport height
          overflowY: "auto",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        {/* 🔥 BIG chart */}
        <div style={{ height: chartHeight }}>
          <Bar data={chartData} options={options} />
        </div>
      </div>
      <div className="overflow-x-auto my-6">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm col-12">
          {/* Table Header */}
          <thead className="bg-gray-100 border-b border-gray-200">
            <tr>
              <th className="p-3 text-left text-gray-700 uppercase tracking-wider">
                Sr
              </th>
              <th className="p-3 text-left text-gray-700 uppercase tracking-wider">
                Origin
              </th>
              <th className="p-3 text-left text-gray-700 uppercase tracking-wider">
                Count
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center p-4 text-gray-500">
                  No leads data available
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition`}
                >
                  <td className="p-3 text-gray-800 font-medium">{index + 1}</td>
                  <td className="p-3 text-gray-800 font-medium">
                    {item.origin}
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {item.count}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadsByOriginChart;
